import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-success-popup',
  templateUrl: './success-popup.component.html'
})
export class SuccessPopupComponent {

  @Input() content!: { message : string, img : string, button : string };
  @Input() action!: () => void 
  doAction()
  {
    return this.action();
  }

}
